export const getVideoCompletionPercentage = (
  duration: number,
  currentTimestamp: number,
): number => {
  if (duration <= 0 || currentTimestamp < 0 || !currentTimestamp) return 0;
  if (currentTimestamp >= duration) return 100;

  const percentage = (currentTimestamp / duration) * 100;
  return Math.min(Math.max(Math.floor(percentage), 0), 100);
};
